import logoGrupoProvinciaBlanco from '/assets/logoGrupoProvinciaBlanco.svg';
import logoProvinciaARTblanco from '/assets/logoProvinciaARTblanco.svg';

export default function Footer() {
    return(
      <footer className="w-full mt-auto flex flex-col border-t-4 border-t-[#25B4BD]">
      <div className="w-full h-[100px] p-4 flex justify-center items-center bg-blue-primary gap-x-28 ">
        <img alt="logo-grupo-provincia" height={28} src={logoGrupoProvinciaBlanco} width={89.49} />
        <img alt="logo-provincia-art" height={45} src={logoProvinciaARTblanco} width={145.03} />
      </div>
    </footer>
    )
}